export const AGGRESSIVE = 'aggressive'
export const MODERATE = 'moderate'
export const CONSERVATIVE = 'conservative'
